import React from 'react';

import { Inject } from '@odinjs/odin';

import { Endpoint, getFilterDates, isIntercambio } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { HpmsContextMenuBeneficiaryChange } from '@philips-emr/hpms-stipulator-components';
import { AutocompleteAPI, FetchAPI, FilterAPI } from '@philips-emr/tws-components';
import Controller, { OnDynamicContentRender, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { RenderEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

interface Data {
  dtContratacao: string;
  dsTitularidade: string;
  cdUsuarioPlano: string;
  dtRescisao: string;
  ieSituacao: string;
  nmPessoaFisica: string;
  nrSeqSegurado: number;
  cdPessoaFisica: string;
}

interface DefaultFilterValues {
  vlDominioData: object;
  cdSituacao: object;
  vlDominio: object;
}

@Controller({ fragment: 'beneficiary-change', component: 'panel-beneficiary-change' })
class BeneficiaryChangeController extends BaseController {

  @Inject('fetch-beneficiary-change')
  private fetchAPI: FetchAPI;
  @Inject('fetch-sub-estipulante')
  private fetchSubestipulante: FetchAPI;

  @OnDynamicContentRender({ target: ['data-table-beneficiary-change'] })
  onDynamicContentRender(event: RenderEvent): void {
    const { entry, render, data } = event;
    const { nrSeqSegurado, cdPessoaFisica } = data as Data;

    if (entry === 'contextMenu') {
      const renderData: Function = () => {
        return (
          <HpmsContextMenuBeneficiaryChange nrSeqBeneficiario={nrSeqSegurado} cdPessoaFisica={cdPessoaFisica}></HpmsContextMenuBeneficiaryChange>
        );
      };
      render(renderData);
    }
  }

  @OnMount({ target: 'filter-beneficiary-change' })
  onFilterMount(event: MouseEvent): void {
    const api = event.target as unknown as FilterAPI;
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();

    const now = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(now.getMonth() - 3);

    void HttpService.get(Endpoint.GET.DEFAULT_FILTER_VALUES_ALT_BENEF, { nrSeqContrato }).then(response => {
      const value = response.body as DefaultFilterValues;
      api.setData({
        dtInicio: lastMonth.toISOString().slice(0, 10),
        dtFim: now.toISOString().slice(0, 10),
        vlDominioData: value.vlDominioData,
        cdSituacao: value.cdSituacao,
        vlDominio: value.vlDominio,
      });
    });
    this.fetchAPI.forceFetch();
  }

  @OnMount({ target: 'autocomplete-sub-estipulante' })
  onAutocompleteMount(event: MouseEvent): void {
    const api = event.target as unknown as AutocompleteAPI;

    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && this.fetchSubestipulante.setParameters({ ...this.fetchSubestipulante.getParameters(), nrSeqSubestipulante });

    if (isIntercambio() || nrSeqSubestipulante) {
      api.setEnabled(false);
    }
  }

  @OnSubmit({ target: 'filter-beneficiary-change' })
  onSubmitFilter(event: SubmitEvent): void {
    const { record, target } = event;
    const api = target as unknown as FilterAPI;

    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    if (nrSeqSubestipulante) {
      nrSeqSubestipulante && this.fetchAPI.setParameters({ ...this.fetchAPI.getParameters(), nrSeqSubestipulante });

      if (record && record.dtInicio && record.dtFim) {
        return;
      }

      const { dtInicio, dtFim } = getFilterDates();
      !record.dtInicio && (record.dtInicio = dtInicio);
      !record.dtFim && (record.dtFim = dtFim);

      api.setData({});
      api.setData({ ...api.getRecord(), dtInicio: record.dtInicio, dtFim: record.dtFim });
    }
  }

}

export default BeneficiaryChangeController;
